import * as stylex from '@stylexjs/stylex';
import { MdPsychology } from 'react-icons/md';
import { LabeledSection } from '~pages/Profile/components/LabeledSection';
import { styles } from './styles';
import type { PublicProfile } from '~pages/Profile/query';
export function Personality({
  personality
}: {
  personality: PublicProfile['personality'];
}) {
  if (!personality) return null;
  return <LabeledSection label="Personality" icon={<MdPsychology size={18} {...stylex.props(styles.icon)} />}>
      <div {...stylex.props(styles.row)}>
        <span {...stylex.props(styles.code)}>{personality.code}</span>
        <span {...stylex.props(styles.description)}>{personality.description}</span>
      </div>
    </LabeledSection>;
}